import React from "react";
import { Link } from "react-router-dom";
import { CalendarCheck } from "lucide-react";
import Seo from "../seo";
import { IMAGES } from "../api";
import { Reveal, Chapter, Breadcrumbs } from "../components/motion";

const FACTS = [
    ["Qualifications", "MBBS, MS (General Surgery), MCh (Urology)"],
    ["Current position", "Consultant Urologist"],
    ["Hospital affiliation", "Preethi Multispeciality Hospital, Madurai, Tamil Nadu"],
    ["Areas of clinical interest", "Kidney stone disease, prostate conditions, urethral stricture and reconstructive urology, men's health, urological oncology, pediatric urology"],
    ["Professional memberships", "USI · SZUSI · KUA · ASI · IAGES"],
];

export default function About() {
    return (
        <div className="mx-auto max-w-7xl px-5 py-14 lg:px-10 lg:py-20">
            <Seo title="About Dr. Krishnakanth AVB | Consultant Urologist, Madurai"
                description="Professional profile of Dr. Krishnakanth AVB, Consultant Urologist at Preethi Multispeciality Hospital, Madurai — qualifications, clinical interests and practice philosophy." />
            <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "About" }]} />
            <div className="mt-12 grid gap-14 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20">
                <Reveal>
                    <div className="relative">
                        <div className="absolute left-1/2 top-1/2 h-[105%] w-[105%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(37,99,235,0.10),transparent_70%)]" aria-hidden="true" />
                        <div className="arch-frame absolute inset-x-6 bottom-0 top-24 bg-gradient-to-b from-sky-100/80 to-blue-50/30" aria-hidden="true" />
                        <img src="/assets/portrait-cutout.png" alt="Dr. Krishnakanth AVB, Consultant Urologist"
                            className="relative w-full [mask-image:linear-gradient(to_bottom,black_88%,transparent_99%)]" data-testid="about-doctor-image" />
                    </div>
                </Reveal>
                <div>
                    <Chapter index={1} label="Professional Profile" />
                    <Reveal>
                        <h1 className="mt-8 font-display text-4xl font-medium leading-tight text-navy sm:text-5xl">
                            Dr. Krishnakanth AVB
                        </h1>
                        <p className="mt-3 font-mono-label text-steel">Consultant Urologist</p>
                        <p className="mt-8 max-w-2xl text-base leading-relaxed text-steel md:text-lg">
                            Dr. Krishnakanth AVB is a Consultant Urologist providing evaluation and management of a broad
                            range of adult urological conditions, with an emphasis on evidence-based diagnosis, appropriate
                            treatment selection and patient education.
                        </p>
                        <p className="mt-5 max-w-2xl text-base leading-relaxed text-steel">
                            His practice is guided by established international guidance — including the European Association
                            of Urology (EAU) and American Urological Association (AUA) guidelines — and by the belief that
                            patients make better decisions when they genuinely understand their condition.
                        </p>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <ul className="mt-10 divide-y divide-border border-y border-border">
                            {FACTS.map(([k, v]) => (
                                <li key={k} className="grid grid-cols-1 gap-1 py-5 sm:grid-cols-[180px_1fr] sm:gap-6">
                                    <span className="font-mono-label text-[0.62rem] pt-0.5 text-steel">{k}</span>
                                    <span className="text-sm leading-relaxed text-navy">{v}</span>
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <Link to="/appointment" data-testid="about-book-appointment-btn"
                            className="mt-10 inline-flex items-center gap-2 rounded-full bg-navy px-7 py-4 text-sm font-semibold text-white transition-all duration-300 hover:bg-accent hover:shadow-lg">
                            <CalendarCheck className="h-4 w-4" aria-hidden="true" />
                            Book an Appointment
                        </Link>
                    </Reveal>
                </div>
            </div>
        </div>
    );
}
